import { createAction, props } from '@ngrx/store';
import {
  CreateDynamicPermissionParam,
  GetDynamicPermissionsByQueryParam,
  GetDynamicPermissionsParam,
  UpdateDynamicPermissionParam,
} from '@resident-select/domain/dynamic-permission';

export const GetDynamicPermissionsCommand = createAction(
  'GetDynamicPermissionsCommand',

  props<GetDynamicPermissionsParam>(),
);

export const GetDynamicPermissionsByQueryCommand = createAction(
  'GetDynamicPermissionsByQueryCommand',
  props<GetDynamicPermissionsByQueryParam>(),
);

export const CreateDynamicPermissionCommand = createAction(
  'CreateDynamicPermissionCommand',
  props<CreateDynamicPermissionParam>(),
);
export const UpdateDynamicPermissionCommand = createAction(
  'UpdateDynamicPermissionCommand',
  props<UpdateDynamicPermissionParam>(),
);
